<template>
  <div>
    <div v-if="rangeType.includes(type)">
      <DatePicker :value="startTime"
                  :type="dateType"
                  :format='format'
                  :placeholder="placeholder"
                  @on-change="startChange"
                  :options="startTimeOption"
                  :editable='editable'></DatePicker>
      <span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>
      <DatePicker :value="endTime"
                  :type="dateType"
                  :format='format'
                  :placeholder="placeholder"
                  @on-change="endChange"
                  :options="endTimeOption"
                  :editable='editable'></DatePicker>
    </div>
    <div v-else>
      <DatePicker :value="value"
                  :type="dateType"
                  :format='format'
                  :placeholder="placeholder"
                  @on-change="change"
                  :editable='editable'></DatePicker>
    </div>
  </div>

</template>

<script>
export default {
  name: 'DatePickerWrapper',
  props: {
    value: {
      type: [String, Array],
      default: undefined
    },
    type: {
      type: String,
      default: 'date'
    },
    format: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    startTime () {
      return this.value ? this.value[0] : ''
    },
    endTime () {
      return this.value ? this.value[1] : ''
    },
    dateType () {
      if (this.rangeType.includes(this.type)) {
        if (this.type === 'monthrange') {
          return 'month'
        } else if (this.type === 'yearrange') {
          return 'year'
        }
      }
      return this.type
    }
  },
  data () {
    return {
      rangeType: ['monthrange', 'yearrange'],
      result: undefined,
      startTimeOption: undefined,
      endTimeOption: undefined,
      startTimeResult: undefined,
      endTimeResult: undefined
    }
  },
  watch: {
    startTimeResult (value) {
      this.endTimeOption = {
        disabledDate (endTime) {
          return endTime < new Date(value)
        }
      }
    },
    endTimeResult (value) {
      this.startTimeOption = {
        disabledDate (startTime) {
          return startTime > new Date(value)
        }
      }
    }
  },
  mounted () {
    this.startTimeResult = this.value ? this.value[0] : ''
    this.endTimeResult = this.value ? this.value[1] : ''
  },
  methods: {
    change (value) {
      this.$emit('input', value)
    },
    startChange (value) {
      this.startTimeResult = value
      let r = [this.startTimeResult, this.endTimeResult]
      this.$emit('input', r)
    },
    endChange (value) {
      this.endTimeResult = value
      let r = [this.startTimeResult, this.endTimeResult]
      this.$emit('input', r)
    }
  }
}
</script>

<style scoped>

</style>
